module.exports = __webpack_public_path__ + "static/img/11.5bd134d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/11.png
// module id = XjRw
// module chunks = 0